export default __webpack_public_path__ + "static/media/dirt.59ed3279.jpg";